import { render, staticRenderFns } from "./TrsServerSelection.vue?vue&type=template&id=2cf979ae&scoped=true&"
import script from "./TrsServerSelection.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TrsServerSelection.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TrsServerSelection.vue?vue&type=style&index=0&id=2cf979ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf979ae",
  null
  
)

export default component.exports